<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: mobai
 * @LastEditTime: 2022-09-21 17:11:03
-->
<template>
  <div class="container">
    <section class="heder">
      <div class="title"><span></span>驻企服务员明细表</div>
      <div class="tip">
        <div>注意事项：</div>
        <div>1、诉求走访-入驻情况中的各区县驻企服务员数和各区县入驻企业数</div>
        <div>2、五企培育，各企业驻企服务员的信息展示</div>
        <div>3、驻企员人数统计去重</div>
      </div>
    </section>
    <section>
      <el-button
        style="float: right; margin-bottom: 15px"
        type="primary"
        @click="
          importDialogVisible = true
          importStep = 0
        "
        >导入</el-button
      >
    </section>
    <section class="body">
      <el-table
        :data="tableList"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="450"
      >
        <el-table-column label="文件名称" align="center">
          <template slot-scope="scope">
            <a style="color: #1890ff" :href="scope.row.ossUrl">{{
              scope.row.fileName
            }}</a>
          </template>
        </el-table-column>
        <el-table-column label="导入状态" align="center">
          <template slot-scope="scope">
            <div>
              <span
                style="
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  border-radius: 8px;
                "
                :class="
                  scope.row.uploadStatus == 1
                    ? 'sk'
                    : scope.row.uploadStatus == 2
                    ? 'green'
                    : 'red'
                "
              ></span>
              {{ scope.row.uploadStatus | uploadStatus }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="操作人" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.userName || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.uploadStatus != 2"
              style="cursor: pointer"
              :class="{
                act: scope.row.uploadStatus == 3 || scope.row.uploadStatus == 4
              }"
              @click="registration(scope.row)"
              >查看</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </section>
    <el-dialog
      title="查看注意事项"
      :visible.sync="centerDialogVisible"
      width="70%"
    >
      <div style="margin-bottom: 20px">
        一、什么样的情况会被标记注意事项？<br />
        1、企业名称为空。请检查企业名称是否填写<br />
        2、驻企服务员名称为空。请检查驻企服务员名称是否填写<br />
        3、该企业不在企业库。请先前往企业档案中添加该企业，否则驾驶舱中无法展示该企业的驻企服务员信息<br />
        二、被标记为注意事项的记录，仍然导入成功
      </div>
      <el-table
        :data="activeTableData"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="300"
      >
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column
          prop="entName"
          label="企业名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="servicePerson" label="驻企员名称">
        </el-table-column>
        <el-table-column label="注意事项">
          <template slot-scope="scope">
            <span>{{ scope.row.reason || '-' }}</span>
            <span
              style="cursor: pointer; color: #1890ff; margin-left: 15px"
              v-if="scope.row.reason == '该企业不在企业库中'"
              @click="goEnt"
              >去补充企业信息</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page" style="margin-top: 20px">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="activeCurrentPage"
          @size-change="activeHandleSizeChange"
          @current-change="activeHandleCurrentChange"
          :page-size="activePageSize"
          :total="activeTotalRecord"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="导入"
      class="import-dialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :visible.sync="importDialogVisible"
      width="40%"
      :before-close="importDialogClose"
    >
      <div class="content-box">
        <div class="step-content">
          <div class="step-item">
            <div class="step-icon" v-show="importStep == 1">
              <i class="el-icon-check"></i>
            </div>
            <div class="step-icon unactive" v-show="importStep == 0">1</div>
            <span>上传模板</span>
          </div>
          <div class="step-line">
            <div class="line" :class="{ active: importStep == 1 }"></div>
          </div>
          <div class="step-item">
            <div class="step-icon unactive">2</div>
            <span>查看结果</span>
          </div>
        </div>
        <div class="content-temp">
          <import-temp
            ref="uploadTemp"
            @uploadOver="uploadOver"
            @uploadFail="uploadFail"
            v-if="importStep == 0"
          />
          <div class="upload-finish" v-else>
            <div class="el-icon-check uploding-icon"></div>
            <div>文件上传成功</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false" v-show="importStep == 0"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitUpload"
          v-show="importStep == 0"
          :disabled="disabledClick"
          >提交</el-button
        >
        <el-button
          type="primary"
          @click="importDialogVisible = false"
          v-show="importStep == 1"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import importTemp from './importTemp.vue'
import {
  updateEntPolicy,
  getEntAppealImportHistoryList,
  getEntAppealImportFailList,
  downLoadImportAppealTemplate
} from '@api/dataMaintenance/dataMaintenance'
export default {
  components: {
    'import-temp': importTemp
  },
  props: {
    entPolicies: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      downLoadImportAppealTemplate,
      importDialogVisible: false,
      custom: true,
      centerDialogVisible: false,
      show: false,
      tableList: [
        { targetName: '今年兑现金额（万元）', targetValue: 4 },
        { targetName: '与公共预算收入比（%）', targetValue: 4 },
        { targetName: '事项数（个）', targetValue: 4 },
        { targetName: '惠企数（家）', targetValue: 4 }
      ],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      activeCurrentPage: 1,
      activePageSize: 10,
      activeTotalRecord: 0,
      activeTableData: [],
      importStep: 0,
      disabledClick: false,
      actId: null
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getEntAppealImportHistoryList()
  },
  mounted() {},
  filters: {
    uploadStatus(value) {
      switch (value) {
        case 1:
          return '导入中'
        case 2:
          return '导入成功'
        case 3:
          return '存在注意事项'
        case 4:
          return '导入失败'
      }
    }
  },
  methods: {
    importDialogClose() {
      this.getEntAppealImportHistoryList()
      this.importDialogVisible = false
    },
    uploadOver(data) {
      let flag = data.type == 1
      if (flag && data.data.code == '0000') {
        this.importStep = 1
        this.getEntAppealImportHistoryList()
      } else {
        this.$message.error(data.data.msg)
      }
      this.disabledClick = false
    },
    uploadFail(data) {
      this.disabledClick = data
    },
    submitUpload() {
      if (this.disabledClick) return
      this.disabledClick = true
      this.$refs.uploadTemp.submit()
    },
    registration(row) {
      if (row.uploadStatus == 1 || row.uploadStatus == 2) {
        return false
      }
      this.centerDialogVisible = true
      this.actId = row.id
      this.getEntAppealImportFailList(row.id)
    },
    updateFillData() {
      updateEntPolicy({ list: this.tableList }).then((res) => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.show = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getEntAppealImportHistoryList() {
      getEntAppealImportHistoryList({
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.data.code == '0000') {
          this.tableList = res.data.data.results || []
          this.totalRecord = res.data.data.totalRecord || 0
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.getEntAppealImportHistoryList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getEntAppealImportHistoryList()
    },
    activeHandleSizeChange(val) {
      this.activePageSize = val
      this.getEntAppealImportFailList()
    },
    activeHandleCurrentChange(currentPage) {
      this.activeCurrentPage = currentPage
      this.getEntAppealImportFailList()
    },
    getEntAppealImportFailList() {
      getEntAppealImportFailList({
        pageNum: this.activeCurrentPage,
        pageSize: this.activePageSize,
        historyId: this.actId
      }).then((res) => {
        if (res.data.code == '0000') {
          this.activeTableData = res.data.data.results || []
          this.activeTotalRecord = res.data.data.totalRecord || 0
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    goEnt() {
      this.$store.dispatch('permission/setCurrentRoue', {
        name: '企业互动',
        href: '/corporateInteraction'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 12px 0;
  background: #fff;
  .heder {
    margin-bottom: 15px;
    > .title {
      display: flex;
      align-items: center;
      line-height: 20px;
      > span {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #46a6ff;
        border-radius: 3px;
        margin-right: 6px;
      }
    }
    > .tip {
      margin: 20px 0;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.7);
      padding: 5px 10px;
      line-height: 24px;
      background-color: #fafafa;
    }
  }
  .body {
    .act {
      color: #1890ff;
    }
    .sk {
      background: grey;
    }
    .green {
      background: green;
    }
    .red {
      background: red;
    }
  }
  .import-dialog {
    /deep/.el-dialog__body {
      padding: 20px;
    }
    .content-box {
      width: 80%;
      margin: auto;
      .step-content {
        display: flex;
        height: 24px;
        line-height: 24px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        text-align: left;
        font-family: PingFangSC-Medium;
        justify-content: space-between;
        margin-bottom: 20px;
        .step-item {
          display: flex;
          .step-icon {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            line-height: 20px;
            text-align: center;
            margin-top: 3px;
            border: 1px solid #1890ff;
            margin-right: 8px;
            background-color: white;
            color: #1890ff;
          }
          .unactive {
            background-color: #1890ff;
            color: white;
          }
          .active-info {
            color: #1890ff;
          }
        }
        .step-line {
          position: relative;
          flex: 1;
          .line {
            background-color: rgba(0, 0, 0, 0.1);
            height: 1px;
            position: absolute;
            left: 10px;
            right: 10px;
            top: 11px;
          }
          .active {
            background-color: #1890ff;
          }
        }
      }
      .content-temp {
        .upload-finish {
          text-align: center;
          .uploding-icon {
            border-radius: 50%;
            background-color: #1890ff;
            color: white;
            width: 100px;
            line-height: 100px;
            height: 100px;
            margin: 0 auto 20px;
            font-size: 40px;
          }
          .show-history {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
